<div class="landing-page">
  <div class="landing-hero">
    <main class="landing-main">
      <h1 class="landing-main__title">Business Finance Made Easy</h1>
      <hr class="landing-main__divider" aria-hidden="true" />
      <p class="landing-main__subtitle">Your funding application, simplified.</p>
    </main>
  </div>

  <section class="landing-cards" aria-label="Get started">
    <div class="landing-cards__card">
      <div class="landing-cards__icon-col" aria-hidden="true">
        <div class="landing-cards__icon-wrap">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
      </div>
      <div class="landing-cards__content">
        <h2 class="landing-cards__title">Already registered?</h2>
        <p class="landing-cards__desc">Log in to access your CapX Flow account.</p>
        <button
          mat-flat-button
          class="landing-cards__btn landing-cards__btn--navy"
          data-testid="landing-login"
          [routerLink]="['/auth/login']"
        >
          Log in
          <svg class="landing-cards__arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M5 12h14M13 6l6 6-6 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
      <div class="landing-cards__divider" aria-hidden="true"></div>
      <div class="landing-cards__nav">
        <button
          class="landing-cards__circle-btn"
          aria-label="Log in"
          matTooltip="Log in"
          [routerLink]="['/auth/login']"
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M5 12h14M13 6l6 6-6 6"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="landing-cards__card landing-cards__card--accent">
      <div class="landing-cards__icon-col" aria-hidden="true">
        <div class="landing-cards__icon-wrap landing-cards__icon-wrap--red">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </div>
      </div>
      <div class="landing-cards__content">
        <h2 class="landing-cards__title">New to CapX Flow?</h2>
        <p class="landing-cards__desc">
          Get a free assessment and see how we can help your business grow.
        </p>
        <button
          mat-flat-button
          class="landing-cards__btn landing-cards__btn--red"
          data-testid="landing-register"
          [routerLink]="['/auth/register']"
        >
          Start free assessment
          <svg class="landing-cards__arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M5 12h14M13 6l6 6-6 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
      <div class="landing-cards__divider" aria-hidden="true"></div>
      <div class="landing-cards__nav">
        <button
          class="landing-cards__circle-btn"
          aria-label="Start free assessment"
          matTooltip="Start free assessment"
          [routerLink]="['/auth/register']"
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M5 12h14M13 6l6 6-6 6"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </section>

  <section class="landing-features" aria-label="Why CapX Flow">
    <div class="landing-features__item">
      <div class="landing-features__icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="2.765 2.819 94.416 96.671"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M 4.5,51.5 A 45.5,45.5 0 0 1 95.5,51.5 A 45.5,45.5 0 0 1 4.5,51.5 Z M 7.3,51.5 A 42.7,42.7 0 0 0 92.7,51.5 A 42.7,42.7 0 0 0 7.3,51.5 Z"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(30,  50, 51.5)"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(60,  50, 51.5)"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(120, 50, 51.5)"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(150, 50, 51.5)"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(180, 50, 51.5)"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(210, 50, 51.5)"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(240, 50, 51.5)"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(300, 50, 51.5)"
          />
          <ellipse
            fill="currentColor"
            cx="50"
            cy="15.5"
            rx="1.5"
            ry="2.5"
            transform="rotate(330, 50, 51.5)"
          />
          <ellipse fill="#d62728" cx="50" cy="15.5" rx="1.5" ry="2.5" />
          <path
            fill="#d62728"
            d="M 55.500431,60.084066 47.667529,53.569182 47.500431,38.656211 c -0.178039,-15.889474 0.324936,-18.186842 3.698336,-16.892347 1.777179,0.681967 2.134566,3.26095 2.134566,15.403465 v 14.584355 l 6.598937,5.524943 c 4.163501,3.485879 6.325243,6.238178 5.857348,7.457491 -1.073256,2.796861 -1.64799,2.537118 -10.289187,-4.650052 z M 12,52 c 0,-0.733333 1.8,-1.333333 4,-1.333333 2.2,0 4,0.6 4,1.333333 0,0.733333 -1.8,1.333333 -4,1.333333 -2.2,0 -4,-0.6 -4,-1.333333 z m 68,0 c 0,-0.733333 1.76459,-1.333333 3.921311,-1.333333 2.156721,0 4.292131,0.6 4.745356,1.333333 0.490404,0.79349 -1.097266,1.333333 -3.921311,1.333333 C 82.13541,53.333333 80,52.733333 80,52 Z"
          />
        </svg>
      </div>
      <div class="landing-features__text">
        <p class="landing-features__title">24-Hour Decision</p>
        <p class="landing-features__desc">You'll know fast.</p>
      </div>
    </div>

    <div class="landing-features__item">
      <div class="landing-features__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.995 96.250" aria-hidden="true">
          <g transform="translate(-2.2124221,-3.1199568)">
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="m 42.888299,99.368854 c -1.95523,-0.0561 -6.836841,-2.09071 -10.848024,-4.52131 -4.011183,-2.4306 -10.161434,-7.26156 -13.667226,-10.73547 C 14.867258,80.638166 10.215687,74.122756 8.0362255,69.633389 5.8567645,65.144022 3.5508435,57.870903 2.9119585,53.470903 2.2730725,49.070902 2.0262234,38.97628 2.3634035,31.038408 c 0.560239,-13.189095 0.85817,-14.531882 3.45816,-15.586113 1.564807,-0.63449 5.7304905,-1.531939 9.2570755,-1.99433 3.526584,-0.462391 11.176584,-3.28363 17,-6.2694204 10.588029,-5.428709 10.588029,-5.428709 21.222066,0.02359 7.235122,3.7096024 13.194304,5.7419604 18.644232,6.3585494 4.405608,0.498438 8.706309,1.745015 9.557113,2.770172 0.997939,1.202443 1.59612,8.594821 1.685561,20.830318 0.120863,16.534089 -0.239311,19.96843 -2.808532,26.779961 -1.620946,4.297461 -5.342418,10.986043 -8.269939,14.863516 -3.185385,4.219012 -9.407197,9.781784 -15.49432,13.853104 -6.239615,4.17331 -11.545772,6.7637 -13.726521,6.701099 z m -0.221631,-6.56462 c 0.505947,0 4.467917,-2.29319 8.804377,-5.09598 4.336461,-2.80279 10.409475,-7.964531 13.495587,-11.470539 3.086111,-3.506008 6.827335,-9.625208 8.31383,-13.598222 1.486495,-3.973014 3.082371,-10.453913 3.54639,-14.401997 0.46402,-3.948084 0.428782,-11.60583 -0.07831,-17.017212 C 75.826564,21.381406 75.826564,21.381406 67.656851,19.828815 63.163509,18.974889 55.75042,16.379564 51.183319,14.061426 42.8795,9.8466276 42.8795,9.8466276 33.456588,14.560719 c -5.232106,2.617516 -12.612957,5.11266 -16.59564,5.610264 -7.1727275,0.896173 -7.1727275,0.896173 -7.8888845,13.098046 -0.393886,6.71103 -0.122099,15.501873 0.603971,19.535207 0.7260705,4.033334 2.8100885,10.333334 4.6311505,14.000001 1.821062,3.666667 5.219425,8.69547 7.551917,11.175119 2.332492,2.479648 7.783917,6.829648 12.114277,9.666668 4.33036,2.83702 8.287338,5.15821 8.793285,5.15821 z"
            />
            <path
              fill="#d62728"
              d="M 39.374543,64.804237 c -0.811133,0 -4.359874,-2.929132 -7.886092,-6.509183 -4.082836,-4.145166 -6.238777,-7.413802 -5.936257,-9 0.261277,-1.36995 1.683665,-2.664825 3.160863,-2.877499 1.610583,-0.231878 4.247875,1.24376 6.587679,3.685988 3.901864,4.07267 3.901864,4.07267 13.440215,-6.270655 8.430478,-9.141953 9.793146,-10.131863 11.732034,-8.522729 1.206526,1.001328 2.193684,2.694208 2.193684,3.761956 0,1.067748 -4.908902,7.294281 -10.90867,13.836741 -5.999768,6.542459 -11.572324,11.895381 -12.383456,11.895381 z"
            />
          </g>
        </svg>
      </div>
      <div class="landing-features__text">
        <p class="landing-features__title">Simple &amp; Transparent</p>
        <p class="landing-features__desc">No hidden costs.</p>
      </div>
    </div>

    <div class="landing-features__item">
      <div class="landing-features__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89.655 94.072" aria-hidden="true">
          <g transform="translate(-1.9922011,-1.9067919)">
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M 35.657842,94.771239 C 22.626122,91.079081 9.9684248,79.250428 4.984349,66.106778 0.954477,55.479487 0.998947,41.202732 5.095215,30.514433 9.299337,19.544713 20.175852,8.694181 31.066919,4.6047732 41.596192,0.6512138 56.068302,1.0842293 65.362572,5.6309229 c 21.30037,10.4199931 31.61161,36.6114291 23.54759,59.8129291 -3.73716,10.752412 -13.93925,22.023279 -24.30145,26.847273 -7.92429,3.689052 -20.79284,4.791454 -28.95087,2.480114 z m 25.93015,-8.735882 c 13.25274,-5.862314 22.14919,-19.499286 23.17787,-35.528309 0.53914,-8.40087 0.15405,-10.641333 -3.05992,-17.803007 -9.56588,-21.315629 -31.4211,-29.9303106 -51.049133,-20.122067 -9.18492,4.58976 -13.915344,9.524084 -18.460252,19.255963 -4.366932,9.350782 -4.366932,23.98255 0,33.333332 9.679097,20.725568 30.152935,29.374192 49.391435,20.864088 z"
            />
            <path
              class="icon-letters"
              fill="currentColor"
              fill-rule="evenodd"
              d="M 22.508683,65.313762 c -1.020406,-1.229514 -1.413685,-6.976938 -1.16326,-16.999999 0.378335,-15.142493 0.378335,-15.142493 9.128316,-15.531047 7.259673,-0.322374 9.360323,0.09153 12.333343,2.430107 4.32772,3.40419 4.84349,10.106816 1.13054,14.692107 -2.3994,2.963133 -2.38073,3.158025 0.85718,8.951281 2.72379,4.87339 2.98108,7.098211 1.4528,7.098211 -4.1497,0 -7.4173,0.475509 -12.51202,-8.241002 -2.654843,-4.54215 -2.654843,-4.54215 -3.091883,1.435946 -0.55233,6.164396 -4.498877,6.164396 -8.135016,6.164396 z M 27.723759,43.17127 c 0,-6.666667 0,-6.666667 4.46001,-6.666667 4.705023,0 8.873323,3.292877 8.873323,7.00975 0,3.511526 -3.89636,6.323583 -8.761903,6.323583 -4.57143,0 -4.57143,0 -4.57143,-6.666666 z"
            />
            <path
              class="icon-letters"
              fill="currentColor"
              fill-rule="evenodd"
              d="M 52.819182,63.347106 c -3.81203,-3.406048 -4.33733,-4.754511 -4.80451,-12.333333 -0.44814,-7.270004 -0.0642,-9.188763 2.63653,-13.175836 2.72085,-4.016802 3.99647,-4.72161 9.16021,-5.061214 7.72698,-0.508182 11.90877,3.456616 12.89746,12.22823 2.04949,18.18303 -8.83438,28.22007 -19.88969,18.342153 z M 55.656682,59.75711 c -2.46368,-2.968556 -3.07414,-15.231544 -0.95839,-19.252507 2.39773,-4.556875 8.07791,-5.136948 10.89654,-1.112781 2.77441,3.961022 2.80613,15.552583 0.0533,19.482772 -2.40835,3.438404 -7.49723,3.887889 -9.99147,0.882516 z"
            />
          </g>
        </svg>
      </div>
      <div class="landing-features__text">
        <p class="landing-features__title">Obligation Free</p>
        <p class="landing-features__desc">Assess your options at no cost.</p>
      </div>
    </div>

    <div class="landing-features__item">
      <div class="landing-features__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.667 94.667" aria-hidden="true">
          <!-- Body arc + head circle: outer/inner pairs → rings via evenodd -->
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="m 4.8194462,91.136905 c -0.503077,-0.50308 -0.913752,-4.56469 -0.912612,-9.0258 0.0025,-9.79937 2.699366,-15.68335 9.7853888,-21.349637 4.750488,-3.79869 6.014539,-4.127755 17.479969,-4.55048 10.439084,-0.384884 13.197174,-0.02816 17.753174,2.296133 9.70972,4.953532 14.21531,13.742054 13.41114,26.159544 l -0.43175,6.66667 -28.085311,0.35912 C 18.372522,91.889975 5.3225222,91.639955 4.8194462,91.136905 Z M 58.542146,81.666665 C 58.460246,67.682625 49.217496,59.99832 32.483795,60.00207 16.762398,60.00557 9.294141,65.930635 8.18727,79.278035 l -0.6127218,7.38863 H 33.072987 58.571426 Z M 24.302826,50.720645 C 9.380949,41.622243 15.575248,17.333333 32.817452,17.333333 c 11.359644,0 17.758774,6.345576 17.748994,17.600453 -0.0124,14.313907 -14.44821,22.991135 -26.26362,15.786859 Z M 39.931446,47.319531 c 4.89518,-2.531394 6.63998,-5.755224 6.63998,-12.268535 0,-6.329462 -2.96033,-10.752667 -8.84092,-13.209735 -14.783897,-6.177105 -25.096304,17.82524 -11.012316,25.631395 4.23356,2.346483 8.474596,2.297335 13.213256,-0.153125 Z"
          />
          <!-- Chat box -->
          <path
            fill="currentColor"
            d="M 51.904756,38.873316 c 0,-2.735548 5.22886,-5.539984 10.32927,-5.539984 9.56278,0 9.67073,-0.157874 9.67073,-14.142651 V 6.666666 h -17.24885 -17.24886 l -0.41781,4.230651 c -0.22979,2.326858 -1.16781,4.476858 -2.08448,4.777778 -2.46143,0.80803 -2.244101,-11.2176028 0.22787,-12.6088418 1.042,-0.586439 10.492,-0.766253 21,-0.399587 l 19.10547,0.666667 0.37833,15.1424928 c 0.25043,10.023061 -0.14285,15.770486 -1.16326,16.999999 -0.99453,1.198331 -4.2947,1.857507 -9.29964,1.857507 -4.26693,0 -8.12887,0.6 -8.5821,1.333334 -1.00058,1.618968 -4.66667,1.78131 -4.66667,0.20665 Z"
          />
          <!-- T letter -->
          <path
            fill="#d62728"
            d="M 54.571426,21.333333 c 0,-1.955556 -0.88889,-2.666667 -3.33333,-2.666667 -1.83334,0 -3.33334,-0.6 -3.33334,-1.333333 0,-0.740741 3.55556,-1.333333 8,-1.333333 4.44445,0 8,0.592592 8,1.333333 0,0.733333 -1.5,1.333333 -3.33333,1.333333 -2.44444,0 -3.33333,0.711111 -3.33333,2.666667 0,1.466666 -0.6,2.666666 -1.33334,2.666666 -0.73333,0 -1.33333,-1.2 -1.33333,-2.666666 z"
          />
        </svg>
      </div>
      <div class="landing-features__text">
        <p class="landing-features__title">Human Final Interaction</p>
        <p class="landing-features__desc">Real people. Real support when it matters.</p>
      </div>
    </div>
  </section>
</div>
